App.namespace.wrap('es6.views.login.user_manager_login', function (options = {}) {
  const FormHandler = App.es6.shared.default_form_handler;

  const formSelector = '.js-login-form-handler';
  const emailInputSelector = '.email-input-field';
  const passwordInputSelector = '.password-input-field';
  const captchaContainerId = 'recaptcha';
  const noContentClass = 'has-error-no-content';
  let captchaService = null;

  const handleEmptyContentError = (input) => {
    input.addClass(noContentClass);

    input.one('input', () => hideError(input));
  }

  const hideError = (input) => {
    input.removeClass(noContentClass);
  }

  const onSubmitError = (errors, form) => {
    const emailInput = form.find(emailInputSelector);
    const passwordInput = form.find(passwordInputSelector);

    hideError(emailInput);
    hideError(passwordInput);

    if (errors.email && errors.email.length && errors.email[0].length === 0) {
      handleEmptyContentError(emailInput);
    }
    if (errors.password && errors.password.length && errors.password[0].length === 0) {
      handleEmptyContentError(passwordInput);
    }
    if (errors.message && !errors.email && !errors.password) {
      const $errorField = form.find(`[data-error-target="password"]`);
      $errorField.html(errors.message);
      $errorField.closest('.form-group').addClass('has-error');
    }
    if (errors['g-recaptcha-response'] && errors['g-recaptcha-response'].length) {
      const captchaSiteKey = (options && options.captcha && options.captcha.sitekey) ? options.captcha.sitekey : '';
      if (!captchaSiteKey.length) {
        throw new Error('Captcha site key is not provided');
      }

      if (captchaService === null) {
        captchaService = App.components.re_captcha(options.captcha.sitekey);
      }

      captchaService.challenge(captchaContainerId, (token) => {
        form.find('input[name="g-recaptcha-response"]').val(token);
        form.submit();
      });
    }
  }

  const init = () => {
    const formHandlerOptions = {
      formClass: formSelector,
      onSubmitError,
    }
    FormHandler(formHandlerOptions).init()
  }

  return {
    init
  }
});
